/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class HolidaySetService extends services.DataService<Wars.Domain.Model.HolidaySet> {
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getHolidaySets():  ng.IPromise<Wars.Domain.Model.HolidaySet[]>  {
            const query = this.breezeModule.EntityQuery
                .from("HolidaySets") 
                .expand("holidays")
                .orderBy("name");

            return this.executeQuery(query);
        }
        
        public createNewHolidaySet(): Wars.Domain.Model.HolidaySet {
            return this.createNewEntity<Wars.Domain.Model.HolidaySet>("HolidaySet");
        }

        public createHoliday(): Wars.Domain.Model.Holiday {
            return this.createNewEntity<Wars.Domain.Model.Holiday>("Holiday");
        }
    }
}

warsApp.registerService('HolidaySetService', ['breeze', '$q']);